export function findAndAddOption({
  incomingOption,
  availableOptions,
  setAvailableOptions,
  setFieldValue = null,
  keyName = null,
}) {
  if (incomingOption) {
    // console.log("incomingOption", incomingOption);
    setAvailableOptions((prev) => {
      const seen = new Set();
      const result = [];

      const addIfUnique = (obj) => {
        const str = JSON.stringify(obj);
        if (!seen.has(str)) {
          seen.add(str);
          result.push(obj);
        }
      };
      prev.forEach(addIfUnique);
      addIfUnique({ label: incomingOption[1], value: incomingOption[0] });
      return result;
    });

    if (setFieldValue && keyName) setFieldValue(keyName, incomingOption?.[0]);
  }
}
